import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'qw-app-icon',
  templateUrl: './app-icon.component.html',
  styleUrls: ['./app-icon.component.scss']
})
export class AppIconComponent implements OnInit {
  @Input() appAlias: string;

  constructor() { }

  ngOnInit() {
  }

}
